import {WorkloadByHoursAndWeekDaysType, workloadSchema} from '../../component/workload/workload-type';
import {fetchAndDeserialize} from '../../util/api-adapter';
import {ProvidersIdsEnum} from '../../util/type';

export function getWorkloadByHoursAndWeekDays(
    companyId: number,
    catalogId: ProvidersIdsEnum
): Promise<WorkloadByHoursAndWeekDaysType> {
    return fetchAndDeserialize(`/v1/company_stats/${companyId}/attendance/?catalog_id=${catalogId}`, workloadSchema);
}
